<template>
  <el-row :gutter="5">
    <el-table
      :data="tableResult"
      style="width: 100%"
      :row-class-name="tableRowClassName"
    >
      <el-table-column type="index" label="Linha" width="100">
      </el-table-column>
      <el-table-column label="Status" property="status" width="150">
      </el-table-column>
      <el-table-column label="Resultado" property="result"> </el-table-column>
    </el-table>
    <el-row :gutter="5" style="margin-top: 50px">
      <el-col
        :xs="12"
        :sm="12"
        :md="12"
        :lg="12"
        :xl="6"
        :offset="11"
        style="display: flex; justify-content: center"
      >
        <el-button
          type="success"
          @click="reset()"
          >Finalizar</el-button
        >
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import { DeliveryService } from "@/services/delivery/delivery.services";

export default {
  name: "ResultingDelivery",
  props: ["records"],
  methods: {
    reset() {
      this.$emit('reset');
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.status === "Erro") {
        return "warning-row";
      } else if (row.status === "Sucesso") {
        return "success-row";
      }
      return "";
    },
  },
  computed: {},
  data() {
    return {
      tableResult: [],
    };
  },
  async mounted() {
    const vm = this;
    for (const record of vm.records) {
      vm.tableResult.push({ status: "Aguardando", result: "", data: record });
    }

    const loading = vm.$loading(vm.$options.loading);

    const sendDeliveryData = async (data) => {
      if (data.error) {
        throw new Exception(data.error);
      }
      return await DeliveryService.add(data.delivery);
    };

    for (const record of vm.tableResult) {
      record.status = "Processando";
      try {
        if (record.data.error) {
          record.status = "Erro";
          record.result = record.data.error.error;
        } else {
          const response = await sendDeliveryData(record.data);
          record.status = "Sucesso";
          record.result = record.data.cep;
        }
      } catch (e) {
        record.status = "Erro";
        record.result = e;
      }
    }
    loading.close();
  },
};
</script>

<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
